<template>
  <div id="partner-box-item">
    <div class="box-wrapper" :class="{ danger: this.placedLongAgo }">
      <div class="code">{{ box.code }}</div>
      <div class="placed-at">
        <div class="text">
          {{ $t("partnerBoxTypeItem.partnerBoxItem.placedAt") }}
        </div>
        <div class="date">
          {{ $moment(box.date).format("YYYY-MM-DD") }}
        </div>
      </div>
      <div
        class="action-wrapper"
        @click="changeBoxMove"
        v-if="getPartner.moved && getPartner.moved == 1"
      >
        <transition name="fade" mode="out-in">
          <template v-if="boxMove">
            <div class="move-all-box action-text" :key="0">
              {{ $t("partnerBoxTypeItem.partnerBoxItem.box.moveAll") }}
            </div>
          </template>
          <template v-if="!boxMove">
            <div class="leave-all-box action-text" :key="1">
              {{ $t("partnerBoxTypeItem.partnerBoxItem.box.leaveAll") }}
            </div>
          </template>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PartnerBoxItem",
  props: {
    box: {
      type: Object,
      required: true
    },
    isMoving: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data: () => ({
    boxMove: true
  }),
  created() {},
  watch: {
    isMoving: {
      immediate: true,
      handler() {
        this.boxMove = this.isMoving;
      }
    }
  },
  computed: {
    ...mapGetters({
      getPartner: "moving/getPartner"
    }),
    placedLongAgo() {
      const boxPlacedAt = this.$moment(this.box.date);
      return this.$moment().diff(boxPlacedAt, "hours") > 72;
    }
  },
  methods: {
    ...mapActions({
      removeOneBox: "moving/removeOneBox"
    }),
    changeBoxMove() {
      this.boxMove = !this.boxMove;
      if (this.boxMove) {
        this.$emit("add", this.box);
      } else {
        this.$emit("remove", this.box);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#partner-box-item {
  padding-left: 10px;
  margin-top: 5px;
  font-size: 15px;
  .box-wrapper {
    padding: 3px;
    padding-left: 8px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    &.danger {
      color: white !important;
      background: red;
      .action-text {
        color: white !important;
      }
    }
    .code {
      font-weight: bold;
      margin-right: 15px;
    }
    .placed-at {
      display: flex;
      flex-direction: row;
      .text {
        margin-right: 4px;
      }
      .date {
        font-weight: 550;
      }
    }
    .action-wrapper {
      margin-right: 10px;
      margin-left: auto;
      cursor: pointer;
      .action-text {
        font-size: 13px;
        text-align: center;
        font-weight: 550;
        color: $color-font-grey-color;
      }
    }
  }
}
</style>
